import { Navigate, Outlet } from 'react-router-dom'

const BattleRoute = () => {
    const storedUser = localStorage.getItem('limitsUser')

    if (!storedUser) {
        return <Navigate to="/home" />
    }

    try {
        const user = JSON.parse(storedUser)
        const allowedTypes = ['fan', 'artist']

        return allowedTypes.includes(user.type)
            ? <Outlet />
            : <Navigate to="/home" />

    } catch (err) {
        console.error("Invalid user data:", err)
        return <Navigate to="/home" />
    }
}

export default BattleRoute
